<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="clickExit()"
  (emitRightClick)="getReport()"
>
  <form class="out-for-delivery" [formGroup]="outForDeliveryForm">
    <ion-row>
      <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
          <div class="form-group form-group-lg no-margin">
            <label>{{ CONSTS.LABEL }}</label>
          </div>
          <app-form-date-picker
            formControlName="date"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [icon]="SRC.CALENDAR"
            [customClass]="'report-date-picker'"
          ></app-form-date-picker>
      </ion-col>

      <ion-col
        size="12"
        size-sm="6"
        size-md="6"
        size-lg="6"
        size-xl="12"
        class="report-format-container"
      >
          <app-report-format
            [radioButtonValue]="outForDeliveryForm.get('reportFormat')?.value"
            (emitRadioChange)="radioChange($event)"
          ></app-report-format>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <app-download-note numRows="2,000"></app-download-note>
      </ion-col>
    </ion-row>
  </form>
</app-modal-frame>

<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [columns]="PDF_REPORT.COLUMNS"
  [columnsData]="
    (codOutForDeliveryReport &&
      codOutForDeliveryReport.response.CODOutForDelivery) ||
    []
  "
  [dataFields]="PDF_REPORT.DATA_FIELDS"
  [hasSingleSubHeaderView]="false"
>
  @if (codOutForDeliveryReport && codOutForDeliveryReport.response) {
    <ng-container sub-header>
      <table
        aria-hidden="true"
        class="pdf-sub-header-table"
      >
        <tr class="pdf-sub-header-row">
          <td>
            {{ PDF_REPORT.HEADER.LOCATION }}
            {{ codOutForDeliveryReport.response.location }}
          </td>
          <td>{{ codOutForDeliveryReport.response.date }}</td>
        </tr>
      </table>
    </ng-container>
  }
</app-pdf-report-generator>
